import { Box, Typography, useTheme } from '@mui/material';
import { duration } from 'dayjs';
import { Duration } from 'dayjs/plugin/duration';
import { FunctionComponent } from 'react';
import { gameConfigStore } from '../../store/GameConfigStore';
import { gamePlayStore, useGameplaySelector } from '../../store/GameplayStore';
import { useAppSelect } from '../../store/Store';
import { GamePhase, PHASE_DISPLAY_NAMES } from '../../types/GameplayTypes';
import { AsyncAnimationProps } from '../../util/Animation';
import { Log } from '../../util/Logging';
import { FullScreenMessage } from './FullScreenMessage';

const PHASE_DELAYS: Partial<Record<GamePhase, Duration>> = {
	steal: duration(2, 'seconds')
} as const;

const DISABLE_FOR_PHASES: GamePhase[] = ['gameEnd'];

type Props = AsyncAnimationProps & {
	phase: GamePhase;
};

export const PhaseTransition: FunctionComponent<Props> = (props) => {
	const theme = useTheme();
	const controllingTeam = useGameplaySelector(gamePlayStore.selectors.controllingTeam);
	const teamNames = useAppSelect(gameConfigStore.selectors.teamNames);

	Log.game.debug('PhaseTransition', props.show, props.phase);

	return DISABLE_FOR_PHASES.includes(props.phase)
		|| <FullScreenMessage
			show={props.show}
			animationType="fade"
			duration={duration(1.6, 'second')} delay={PHASE_DELAYS[props.phase]}
			onComplete={props.onComplete}
			sx={{
				background: 'rgba(0, 0, 0, 0.75)',
			}}	>
			<Box sx={{
				display: 'flex',
				alignItems: 'center',
				justifyContent: 'center',
				height: '100%',
				width: '100%',
			}}>
				<Box sx={{
					textAlign: 'center',
					paddingY: 4,
					paddingX: 8,
					bgcolor: theme.palette.game.gold,
					borderRadius: '24px',
					border: `6px solid ${theme.palette.game.white}`,
					boxShadow: '0 20px 60px rgba(0, 0, 0, 0.5)',
				}}>
					{(controllingTeam !== undefined)
						&& <Typography variant='h2'>{teamNames[controllingTeam]}</Typography>}

					<Typography
						variant="h2"
						sx={{
							fontWeight: 'bold',
							color: theme.palette.game.textDark,
							textTransform: 'uppercase',
							letterSpacing: '0.1em',
						}}
					>
						{PHASE_DISPLAY_NAMES[props.phase]}
					</Typography>
				</Box>
			</Box>
		</FullScreenMessage>;
};
